// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"48b569cf7cb93fd31c02","908":"ff73250c5db065d2a5fe"}[chunkId] + ".js";
};